<template>
  <div class="salary-management">
    <div class="search">
      <el-select
        v-model="department"
        clearable
        class="gray"
        placeholder="请选择部门"
      >
        <el-option
          v-for="item in departmentList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button class="btn-blue" @click="searchData">搜索</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="员工"></el-table-column>
        <el-table-column prop="salary" label="固定工资">
          <template slot-scope="scope">
            <p class="price-container">
              <el-input
                class="white"
                @input="inputSalary(scope.$index, scope.row.salary)"
                v-model="scope.row.salary"
              ></el-input>
              <span>元/月</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="insurance" label="五险一金">
          <template slot-scope="scope">
            <p class="price-container">
              <el-input
                class="white"
                @input="inputInsurance(scope.$index, scope.row.insurance)"
                v-model="scope.row.insurance"
              ></el-input>
              <span>元/月</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="mealSubsidy" label="餐补">
          <template slot-scope="scope">
            <p class="price-container">
              <el-input
                class="white"
                @input="inputMealSubsidy(scope.$index, scope.row.mealSubsidy)"
                v-model="scope.row.mealSubsidy"
              ></el-input>
              <span>元/天</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="overtimeSubsidy" label="加班工资">
          <template slot-scope="scope">
            <p class="price-container">
              <el-input
                class="white"
                @input="
                  inputOvertimeSubsidy(scope.$index, scope.row.overtimeSubsidy)
                "
                v-model="scope.row.overtimeSubsidy"
              ></el-input>
              <span>元/时</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              type="text"
              @click="saveSalary(scope.row)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import { getDecimal, modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import Employee from "models/employee";
const employee = new Employee();
export default {
  data() {
    return {
      department: "",
      departmentList: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('薪资管理')
    this.getCompanyList();
  },
  methods: {
    //获取部门数据
    getCompanyList() {
      employee.getDeptList().then(res => {
        let departmentList = [];
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            departmentList.push(obj);
          });
          this.departmentList = departmentList;
        }
      });
    },
    //获取列表
    getTableData() {
      let page = this.currentPage;
      let deptId = this.department;
      employee.getEmployeeSalaryList(page, deptId).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let tableData = [];
          res.result.items.map(value => {
            let obj = {};
            obj.employeeId = value.employeeId;
            obj.name = value.name;
            obj.salary = value.salary;
            obj.insurance = value.insurance;
            obj.mealSubsidy = value.mealSubsidy;
            obj.overtimeSubsidy = value.overtimeSubsidy;
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    searchData() {
      if (this.department) {
        this.getTableData();
      } else {
        this.$message.error("请选择部门");
      }
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    saveSalary(row) {
      let data = {};
      data.employeeId = row.employeeId;
      data.overtimeSubsidy = Number(row.overtimeSubsidy);
      data.mealSubsidy = Number(row.mealSubsidy);
      data.salary = Number(row.salary);
      data.insurance = Number(row.insurance);
      employee.postUpdateEmployeeSalary(data).then(res => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            type: "success",
            duration: 1000
          });
          this.getTableData();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000
          });
        }
      });
    },
    //限制固定工资输入
    inputSalary(index, price) {
      let salary = getDecimal(price);
      this.tableData[index].salary = salary;
    },
    //限制五险一金输入
    inputInsurance(index, price) {
      let insurance = getDecimal(price);
      this.tableData[index].insurance = insurance;
    },
    //限制餐补输入
    inputMealSubsidy(index, price) {
      let mealSubsidy = getDecimal(price);
      this.tableData[index].mealSubsidy = mealSubsidy;
    },
    //限制加班工资输入
    inputOvertimeSubsidy(index, price) {
      let overtimeSubsidy = getDecimal(price);
      this.tableData[index].overtimeSubsidy = overtimeSubsidy;
    }
  }
};
</script>
<style lang="scss" scoped>
.salary-management {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    .btn-blue {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .el-table {
      .price-container {
        display: flex;
        color: #666666;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
<style lang="scss">
.salary-management {
  .table {
    .el-table {
      .el-input {
        width: 80px;
        .el-input__inner {
          height: 24px;
          width: 80px;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
